import gql from 'graphql-tag';

const absensiFragment = gql `
  fragment absensiFragment on Absensi {
    id
    uuid
    keterangan
    deskripsi
    tanggal
    jam_mulai
    jam_selesai
  }     
`;

const ALL = gql `
  query all($perPage: Int!, $page: Int, $where: AbsensiWhereWhereConditions) {
    absensi(first: $perPage, page: $page, where: $where) {
      data {
        ...absensiFragment
      }
    }
  }
  ${absensiFragment}
`;

const FIND = gql `
  query find($where: AbsensiFindWhereWhereConditions) {
    absensi: absensiFind(where: $where) {
      ...absensiFragment
    }
  }
  ${absensiFragment}
`;

const CREATE = gql `
    mutation($input: AbsensiCreateInput!,){
        absensiCreate(input: $input){
            id,
            uuid,
            keterangan
        }
    }
`;

const UPDATE = gql `
    mutation($id: ID!, $input:AbsensiUpdateInput!){
        absensiUpdate(id: $id,input:$input){
            id
            uuid
            keterangan
        }
    }
`;

const LIST_KETERANGAN = [
  {value : 'Hadir', label : 'Hadir'},
  {value : 'Work From Home (WFH)', label : 'Work From Home (WFH)'},
  {value : 'Izin', label : 'Izin'},
  {value : 'Sakit', label : 'Sakit'},
  {value : 'Cuti', label : 'Cuti'},
  {value : 'Tanpa Keterangan', label : 'Tanpa Keterangan'},
]

export { ALL, FIND, LIST_KETERANGAN, CREATE, UPDATE};